import React, { FC } from "react";
import Label from "components/Label";

import Media from "components/Media";
import styles from "./styles.module.scss";

const Header: FC = () => {
  return (
    <>
      <Media at={["mobile", "tablet"]}>
        <div className={styles.responsiveContainer}>
          <Label
            linkColor="secondary"
            className={styles.prompt}
            useMarkdown
            color="primary"
          >
            {`Featured in Business Insider’s List of 2022&apos;s Most Promising Consumer Service Companies! [GET STARTED](/start)`}
          </Label>
        </div>
      </Media>
      <Media at={["desktop"]}>
        <div className={styles.container}>
          <Label
            useMarkdown
            className={styles.prompt}
            variant="s2"
            color="primary"
            linkColor="secondary"
          >
            {`Featured in Business Insider’s List of 2022&apos;s Most Promising Consumer Service Companies! [GET STARTED](/start)`}
          </Label>
        </div>
      </Media>
    </>
  );
};

export default Header;
